import React from "react";
import ReactTimeAgo from "react-time-ago";
import TimeAgo from "javascript-time-ago";

import en from "javascript-time-ago/locale/en";
import ru from "javascript-time-ago/locale/ru";

TimeAgo.addDefaultLocale(en);
TimeAgo.addLocale(ru);
const TimesAgo = ({ date, style = "twitter" }) => {
  return date ? (
    <ReactTimeAgo
      date={new Date(date)}
      timeStyle={{
        flavor: "long", // Use 'long' for more detailed time descriptions
        round: "floor", // Rounds down instead of rounding up
      }}
    />
  ) : null;
};

export default TimesAgo;
